import {
  IWidgetController,
  IWidgetControllerConfig,
} from '@wix/native-components-infra/dist/src/types/types';
// DO NOT change. Long imports are intentional here
import { ExperimentsBag } from '@wix/wix-experiments';
import { GroupsPageController } from './page/GroupsPageController';

export async function createGroupsAppController(
  controllerConfig: IWidgetControllerConfig,
  experiments: ExperimentsBag = {},
): Promise<IWidgetController> {
  return new GroupsPageController(controllerConfig, experiments);
}
